import React from 'react';

interface RelatedLinksProps {
  title: string;
  links: string[];
}

const RelatedLinks = ({ title, links }: RelatedLinksProps) => {
  return (
    <div className="h-full">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="h-1 w-24 bg-primary mb-4" />
      <ul className="space-y-2">
        {links.map((link, index) => (
          <li key={index}>
            <a 
              href="#" 
              className="text-gray-600 hover:text-secondary transition-colors"
            >
              {link}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedLinks;